export interface PaginationInfo { page: number; total: number; totalPages: number; }

export function Pagination({
  pagination,
  perPage,
  onGo,
}: {
  pagination: PaginationInfo;
  perPage: number;
  onGo: (p: number) => void;
}) {
  const { page, total, totalPages } = pagination;
  if (!totalPages || totalPages <= 1) return null;
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  let pages: (number | '…')[];
  if (totalPages <= 5) pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  else if (page <= 3) pages = [1, 2, 3, 4, '…', totalPages];
  else if (page >= totalPages - 2) pages = [1, '…', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  else pages = [1, '…', page - 1, page, page + 1, '…', totalPages];

  const navBtn = 'px-3 py-1.5 text-sm font-medium text-slate-300 bg-dark-700 border border-slate-600/50 rounded-lg hover:bg-dark-600 disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div class="px-6 py-4 border-t border-slate-700/50">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p class="text-sm text-slate-400">Showing {start}-{end} of {total} sites</p>
        <div class="flex items-center gap-2">
          <button type="button" class={navBtn} disabled={page <= 1} onClick={() => onGo(page - 1)}>Previous</button>
          <span class="flex items-center gap-1">
            {pages.map((p) => p === '…'
              ? <span class="px-2 text-slate-500">…</span>
              : (
                <button
                  type="button"
                  onClick={() => onGo(p as number)}
                  class={`px-3 py-1.5 text-sm font-medium rounded-lg ${p === page ? 'bg-cyan-500 text-dark-900' : 'text-slate-400 hover:bg-dark-700 hover:text-slate-200'}`}
                >
                  {p}
                </button>
              )
            )}
          </span>
          <button type="button" class={navBtn} disabled={page >= totalPages} onClick={() => onGo(page + 1)}>Next</button>
        </div>
      </div>
    </div>
  );
}
